import React from "react";
import BaseSpread, { CardPosition } from "./BaseSpread";

// Generate position data for Year Ahead spread (12 cards in circle)
// Cards are arranged in a circle representing the 12 months
// Starting at 9 o'clock position and moving counterclockwise (same as astrological spread)
// Each position contains: left, top, width, height (all in percentages)
const generateYearAheadPositions = (spacing: number = 10): CardPosition[] => {
    const cardHeight = spacing * 1.726; // Maintain card aspect ratio (standard tarot card ratio)
    const centerX = 45; // Center of the circle (percentage)
    const centerY = 50; // Center of the circle (percentage)
    const radius = 40; // Radius of the circle (percentage from center)

    const positions: CardPosition[] = [];

    // Calculate positions for 12 cards in a circle
    // Start at 9 o'clock position (270 degrees) and move counterclockwise
    for (let i = 0; i < 12; i++) {
        // Calculate angle for each card (starting at 270 degrees, moving counterclockwise)
        const angle = (270 + (i * 30)) * (Math.PI / 180); // 30 degrees between each card

        // Calculate x and y positions
        const x = centerX + (radius * Math.cos(angle)) - (spacing / 2);
        const y = centerY + (radius * Math.sin(angle)) - (cardHeight / 2);

        positions.push({
            left: x,
            top: y,
            width: spacing,
            height: cardHeight
        });
    }

    return positions;
};

interface YearAheadSpreadProps {
    size?: number;
    cardWidth: number;
    displaySpread: boolean;
    getCard: (index: number) => React.ReactNode;
    spacing?: number; // Spacing between cards (default: 10)
}

const YearAheadSpread = ({ size, cardWidth, displaySpread, getCard, spacing = 10 }: YearAheadSpreadProps) => {
    const positions = generateYearAheadPositions(spacing);

    return (
        <BaseSpread
            positions={positions}
            size={size}
            cardWidth={cardWidth}
            displaySpread={displaySpread}
            getCard={getCard}
            rotatedCards={[]} // No rotated cards in year ahead spread
            name="year-ahead"
        />
    );
};

export default YearAheadSpread; 